module.exports = __webpack_public_path__ + "img/product-ketang-jbxl-01.b74851b1.png";